import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResponseDto } from '@models/responseDto';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserManagementService {
  private readonly userServiceApiUrl = environment.userServiceApiUrl;
  private readonly assessmentHubServiceUrl = environment.assessmentHubServiceUrl;

  constructor(private readonly http: HttpClient) { }

  getAllAccessTypes(): Observable<ResponseDto> {
    return this.http.get<ResponseDto>(
      `${this.userServiceApiUrl}/Access/GetAllRoles`
    );
  }

  inviteUser(inviteJson: any): Observable<ResponseDto> {
    return this.http.post<ResponseDto>(
      `${this.userServiceApiUrl}/User/InviteUser`,
      inviteJson
    );
  }

  getAllFunctions(): Observable<ResponseDto> {
    return this.http.get<ResponseDto>(
      `${this.userServiceApiUrl}/Function/GetAllFunctions`
    );
  }


}
